// extracted by mini-css-extract-plugin
export default {"root":"pEofV","mobile":"ekE40","smallMobile":"wLoDR"};